/* global axios */
import ApiClient from './ApiClient';

class LemitAPI extends ApiClient {
  constructor() {
    super('lemit', { accountScoped: true });
  }

  consult(cpf, provider = 'lemit') {
    return axios.post(`${this.url}/consult`, { cpf, provider });
  }

  createPhoneContact(consultationId, phone, provider = 'lemit') {
    return axios.post(`${this.url}/phone_contact`, {
      consultation_id: consultationId,
      phone,
      provider,
    });
  }

  batch(cpfs, provider = 'lemit') {
    return axios.post(`${this.url}/batch`, { cpfs, provider });
  }

  logs(params = {}, provider = 'lemit') {
    return axios.get(`${this.url}/logs`, {
      params: { ...params, provider },
    });
  }

  downloadBatch(batchId, provider = 'lemit') {
    return axios.get(`${this.url}/batches/${batchId}/download`, {
      params: { provider },
      responseType: 'blob',
    });
  }

  campaignAudience(batchId, phonePriority, provider = 'lemit') {
    return axios.get(`${this.url}/batches/${batchId}/campaign_audience`, {
      params: { phone_priority: phonePriority, provider },
    });
  }

  summary(provider = 'lemit') {
    return axios.get(this.url, { params: { provider } });
  }

  accesses() {
    return axios.get(`${this.url}/accesses`);
  }

  updateAccesses(userIds) {
    return axios.put(`${this.url}/accesses`, { user_ids: userIds });
  }
}

export default new LemitAPI();
